export const NO_CHANGES_TOAST_MESSAGE = "No changes have been made.";
